/**
 * Student Performances Configuration
 *
 * Each student can have multiple performances (recordings, videos, etc.)
 * Performances are displayed on the student dashboard in order from latest to oldest.
 *
 * Structure:
 * {
 *   [studentId]: [
 *     {
 *       id: string,           // Unique identifier
 *       title: string,        // Performance title (e.g., "歌曲表演 - ABC Song")
 *       date: string,         // Date in YYYY-MM-DD format
 *       videoUrl: string,     // URL to the video
 *       thumbnailUrl?: string // Optional thumbnail image
 *     }
 *   ]
 * }
 */

export const performancesConfig = {
  "6895d695d2449d197e357558": [
    {
      id: "perf-001",
      title: "表演",
      date: "2025-09-09",
      videoUrl:
        "https://videos.littlelambenglish.com/6064763ddddf71f082976732b78e0102/47f62ee433234ba29ea84d3b4a38c65d.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/6064763ddddf71f082976732b78e0102/snapshots/febfa14b04fc41658bb65d7b51cbd5fd-00003.jpg",
    },
    {
      id: "perf-002",
      title: "表演",
      date: "2025-11-15",
      videoUrl:
        "https://videos.littlelambenglish.com/f0167f3ddddf71f097d64531958d0102/bdd6a5c63b244245a74de8cdc2873907.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/f0167f3ddddf71f097d64531958d0102/snapshots/fbb0c7664fa44c6fa9f92a83a60a363c-00004.jpg",
    },
    {
      id: "perf-003",
      title: "表演",
      date: "2025-12-20",
      videoUrl:
        "https://videos.littlelambenglish.com/b03e883ddddf71f0a88c5420848d0102/e6d8422c022a44efbaad22dd94501475.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/b03e883ddddf71f0a88c5420848d0102/snapshots/7b613e6fcdc24fdd98f18de0a0fd00bf-00004.jpg",
    },
  ],
  "68a07a4020103d1a5eb7f3b5": [
    {
      id: "perf-001",
      title: "表演",
      date: "2025-09-09",
      videoUrl:
        "https://videos.littlelambenglish.com/6064763ddddf71f082976732b78e0102/47f62ee433234ba29ea84d3b4a38c65d.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/6064763ddddf71f082976732b78e0102/snapshots/febfa14b04fc41658bb65d7b51cbd5fd-00003.jpg",
    },
    {
      id: "perf-002",
      title: "表演",
      date: "2025-11-15",
      videoUrl:
        "https://videos.littlelambenglish.com/f0167f3ddddf71f097d64531958d0102/bdd6a5c63b244245a74de8cdc2873907.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/f0167f3ddddf71f097d64531958d0102/snapshots/fbb0c7664fa44c6fa9f92a83a60a363c-00004.jpg",
    },
    {
      id: "perf-003",
      title: "表演",
      date: "2025-12-24",
      videoUrl:
        "https://videos.littlelambenglish.com/70fdb8aedf6771f095546632b68f0102/7a10d8a3a50a41e5a111cbad7cb4973b.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/70fdb8aedf6771f095546632b68f0102/snapshots/ed7d48b21e8c4f6588ee0a00807c877d-00005.jpg",
    },
  ],
  "6896e36e9a846d480608d9aa": [
    {
      id: "perf-001",
      title: "表演",
      date: "2025-11-15",
      videoUrl:
        "https://videos.littlelambenglish.com/b03e883ddddf71f0a88c5420848d0102/e6d8422c022a44efbaad22dd94501475.m3u8",
      thumbnailUrl:
        "https://videos.littlelambenglish.com/vod-8e4c4f/b03e883ddddf71f0a88c5420848d0102/snapshots/7b613e6fcdc24fdd98f18de0a0fd00bf-00004.jpg",
    },
  ],

  // Example structure:
  // 'student123': [
  //   {
  //     id: 'perf-001',
  //     title: '歌曲表演 - ABC Song',
  //     date: '2025-12-15',
  //     videoUrl: 'https://videos.littlelambenglish.com/performances/student123/abc-song.mp4',
  //     thumbnailUrl: 'https://videos.littlelambenglish.com/performances/student123/abc-song-thumb.jpg',
  //   },
  // ],
};

/**
 * Get performances for a student, sorted by date (latest first)
 * @param {string} studentId
 * @returns {Array} Sorted array of performances
 */
export function getStudentPerformances(studentId) {
  const performances = performancesConfig[studentId] || [];

  // Sort by date descending (latest first)
  return [...performances].sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });
}
